export default __webpack_public_path__ + "static/media/num-icon5.fbfe76c4.svg";